import { apolloClient } from "@/plugins/vue-apollo.js";

const deleteLandmark = (_variables) => {
  let responseFromApi;
  let variables = {
    landmarkId: _variables,
  };
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/settings/api/mutations/landmark/delete_landmark.graphql"),
      variables: variables,
      update: (store, { data }) => {
        const query = {
          query: require("@/settings/api/queries/landmark/get_landmark_query.graphql"),
          variables: {
            input: {
              limit: 10,
              skip: 0
            }
            // ,
            // filter: {
            //   searchKey: ''
            // }
          },
        };
        store.writeQuery({
          ...query,
          data: data,
        });
      },
    })
    .catch((error) => {
      return error;
    });
  return responseFromApi;
};
export { deleteLandmark };
